import { useState, useContext } from "react";
import Image from "next/image";
import classes from "../../src/socialMediaModule/styles/member.module.css";
import { MoreVertOutlined } from "@mui/icons-material";
import { getMemberRole } from "@utils/constants";
import { time_ago } from "@utils/metrics/timeFunction";
import classNames from "classnames/bind";
import { Divider } from "@mui/material";
import defaultProfilePic from "@public/assets/images/blank-profile-picture.png";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { assignRoleToMember, removeMember } from "@queries/community.queries";
import { Store } from "@store";
import { useRouter } from "next/router";
import { COMMUNITY_MEMBER_ROLES } from "@utils/constants";
import UtsavNewModal from "src/globalModule/views/UtsavNewModal";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
export default function Member({
  data,
  isAdmin,
  handleRemove
}) {
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [role, setRole] = useState(data?.role);
  const router = useRouter();
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null,
    positive: false
  });
  const showOptions = () => {
    if (data.role === COMMUNITY_MEMBER_ROLES.OWNER) {
      return false;
    } else if (data.uid === loggedInUser.uid) {
      return false;
    } else return true;
  };
  const cx = classNames.bind(classes);
  const roleStyle = cx({
    owner: role === COMMUNITY_MEMBER_ROLES.OWNER,
    admin: role === COMMUNITY_MEMBER_ROLES.ADMIN,
    hide: role === COMMUNITY_MEMBER_ROLES.GENERAL
  });
  const makeAdmin = async () => {
    const res = await assignRoleToMember({
      communityID: data.communityID,
      memberID: data.memberID,
      role: COMMUNITY_MEMBER_ROLES.ADMIN,
      accessToken: loggedInUser.accessToken
    });
    if (res) {
      setRole(COMMUNITY_MEMBER_ROLES.ADMIN);
      // swal.fire({
      //   title: "Admin Assigned !",
      //   icon: "success",
      //   background: "#f2f2f2",
      //   backdrop: "rgba(34, 34, 34, 0.4);",
      //   customClass: {
      //     title: `${modalClasses.modalCard__heading}`,
      //     htmlContainer: `${modalClasses.modalCard__msg}`,
      //     actions: `${modalClasses.modalCard__options} `,
      //     cancelButton: `${modalClasses.modalCard__btn} ${modalClasses.modalCard__btn_neg}`,
      //     confirmButton: `${modalClasses.modalCard__btn} ${modalClasses.modalCard__btn_pos}`,
      //   },
      // });
      setErrorModal({
        open: true,
        heading: "Success",
        message: "Admin Assigned !",
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <CheckCircleOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />,
        positive: true
      });
    } else {
      alert("Something went wrong!");
    }
  };
  const removeAdmin = async () => {
    const res = await assignRoleToMember({
      communityID: data.communityID,
      memberID: data.memberID,
      role: COMMUNITY_MEMBER_ROLES.GENERAL,
      accessToken: loggedInUser.accessToken
    });
    if (res) {
      setRole(COMMUNITY_MEMBER_ROLES.GENERAL);
      // swal.fire({
      //   title: "Admin Removed !",
      //   icon: "success",
      //   background: "#f2f2f2",
      //   backdrop: "rgba(34, 34, 34, 0.4);",
      //   customClass: {
      //     title: `${modalClasses.modalCard__heading}`,
      //     htmlContainer: `${modalClasses.modalCard__msg}`,
      //     actions: `${modalClasses.modalCard__options} `,
      //     cancelButton: `${modalClasses.modalCard__btn} ${modalClasses.modalCard__btn_neg}`,
      //     confirmButton: `${modalClasses.modalCard__btn} ${modalClasses.modalCard__btn_pos}`,
      //   },
      // });
      // <UtsavNewModal
      //   open={openErrorModal}
      //   toggleModal={() => setOpenErrorModal(!openErrorModal)}
      //   heading="Success"
      //   message="Admin Removed !"
      //   acceptMsg="Okay"
      //   onAccept={() => setOpenErrorModal(!openErrorModal)}
      //   // rejectMsg="Cancel"
      //   icon={
      //     <CheckCircleOutlineOutlinedIcon
      //       sx={{ fontSize: "3rem", color: "red" }}
      //     />
      //   }
      // />;
      setErrorModal({
        open: true,
        heading: "Success",
        message: "Admin Removed !",
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <CheckCircleOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "green"
        }} />,
        positive: true
      });
    } else {
      alert("Something went wrong!");
    }
  };
  const removeMem = async () => {
    const res = await removeMember({
      communityID: data.communityID,
      memberID: data.memberID,
      accessToken: loggedInUser.accessToken
    });
    if (res) {
      handleRemove(data.memberID);
      // swal.fire({
      //   title: "Member Removed !",
      //   icon: "success",
      //   background: "#f2f2f2",
      //   backdrop: "rgba(34, 34, 34, 0.4);",
      //   customClass: {
      //     title: `${modalClasses.modalCard__heading}`,
      //     htmlContainer: `${modalClasses.modalCard__msg}`,
      //     actions: `${modalClasses.modalCard__options} `,
      //     cancelButton: `${modalClasses.modalCard__btn} ${modalClasses.modalCard__btn_neg}`,
      //     confirmButton: `${modalClasses.modalCard__btn} ${modalClasses.modalCard__btn_pos}`,
      //   },
      // });
      setErrorModal({
        open: true,
        heading: "Success",
        message: "Member Removed !",
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <CheckCircleOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "green"
        }} />,
        positive: true
      });
    } else {
      alert("Something went wrong!");
    }
  };
  function AdminOptions() {
    return <div className={classes.adminMoreOptions} data-sentry-component="AdminOptions" data-sentry-source-file="Member.jsx">
        {role === COMMUNITY_MEMBER_ROLES.ADMIN ? <p onClick={removeAdmin}>Remove Admin</p> : <p onClick={makeAdmin}>Make Admin</p>}
        <p onClick={removeMem}>Remove Member</p>
      </div>;
  }
  function handleClickAway() {
    setShowMoreOptions(false);
  }

  // const onclickHandler = () => viewProfile(data.uid, router);

  return <>
      {/* <Link scroll={false} href={`/profile/${data?.uid}`} passHref> */}
      <a className={`${classes.member}`} onClick={() => {
      // track Event to be applied
    }}>
        {/* style={{ display: "flex" }} */}
        <div className={classes.memberCont}>
          <div className={`${classes.profilePic}`}
        // alt={data.User.name?.charAt(0).toUpperCase()}
        >
            <Image src={data?.User?.dp || defaultProfilePic} alt={`${data?.User?.name} dp`} width="40" height="40" objectFit="cover" style={{
            borderRadius: "50%"
          }} data-sentry-element="Image" data-sentry-source-file="Member.jsx" />
          </div>
          <div className={`${classes.user_info}`} onClick={() => router.push(`/profile/${data?.uid}`)}>
            <div className={classes.user_info_header}>
              <h5 className={`${classes.username}`}>{data?.User?.name}</h5>
              {role !== COMMUNITY_MEMBER_ROLES.GENERAL && <span>&bull;</span>}
              <h6 className={`${classes.badge} ${roleStyle}`}>
                {getMemberRole(role, router.locale)}
              </h6>
            </div>
            <small className={`${classes.timestamp}`}>
              {time_ago(data.joiningTime)}
            </small>
          </div>
          {isAdmin && showOptions() ? <div className={`${classes.moreVert}`}>
              <ClickAwayListener onClickAway={handleClickAway}>
                <button className={`btn-sm ${classes.btn} ${classes.profile_display_cover_more}`} onClick={() => setShowMoreOptions(cur => !cur)} color="success">
                  <MoreVertOutlined />
                </button>
              </ClickAwayListener>

              {showMoreOptions && <AdminOptions />}
            </div> : null}
        </div>
      </a>
      {/* </Link> */}

      {/* style={{ height: "0.5px", margin: "0px 7px", color: "#e2e2e2" }}  */}
      <Divider sx={{
      opacity: 0.25
    }} data-sentry-element="Divider" data-sentry-source-file="Member.jsx" />
      {errorModal.open && <UtsavNewModal open={errorModal.open} toggleModal={() => setErrorModal(prevState => ({
      ...prevState,
      open: true
    }))} heading={errorModal.heading} message={errorModal.message} acceptMsg="Okay" onAccept={errorModal.acceptMethod}
    // rejectMsg="Cancel"
    icon={errorModal.icon} positive={errorModal.positive} />}
    </>;
}